import pinia, { useUserStore } from "@/store";
import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ElMessage } from 'element-plus';
import { getToken, removeToken } from '@/utils/auth';
import { notifyAxiosError, rejectBizError } from '@/api/http-error';

const store = useUserStore(pinia)
let count = 0

function showMask() {
  count+=1
  store.setLoading(true)
}

function hideMask() {
  count-=1
  if (count == 0) {
    store.setLoading(false)
  }
}

export interface HttpResponse<T = unknown> {
  status: number;
  message: string;
  code: number;
  data: T;
}

const service = axios.create({
  baseURL: '', // url = base url + request url
  timeout: 30000 // request timeout
})

if (process.env.VUE_APP_API_BASE_BJH_URL) {
  service.defaults.baseURL = process.env.VUE_APP_API_BASE_BJH_URL;
}

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // let each request carry token
    // this example using the JWT token
    // Authorization is a custom headers key
    // please modify it according to the actual situation
    // store.$patch({
    //   loading: true
    // })
    if (config.method == 'get') {
      if (!config.params || !config.params.isMask) {
        showMask()
      }
    } else if (!config.data) {
      showMask()
    } else if (typeof config.data == 'string') {
      if (!config.data.includes('isMask')) {
        showMask()
      }
    } else if (!config.data.isMask) {
      showMask()
    }
    
    const token = getToken();

    if (token) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // do something
    return Promise.reject(error);
  }
);
// add response interceptors
service.interceptors.response.use(
  (response: AxiosResponse<HttpResponse>) => {
    if (response.config.method == 'get') {
      if (!response.config.params || !response.config.params.isMask) {
        hideMask()
      }
    } else if (!response.config.data) {
      hideMask()
    } else if (typeof response.config.data == 'string') {
      if (!response.config.data.includes('isMask')) {
        hideMask()
      }
    } else if (!response.config.data.isMask) {
      hideMask()
    }

    const res = response.data;
    if (res.code !== 200) {
      if (res.code === 401) {
        ElMessage.error({
          message: '登录超时，请重新登录',
          duration: 2 * 1000,
          onClose: () => {
            removeToken();
            window.location.reload();
          },
        });
      } else {
        return rejectBizError(res.message || 'Error');
      }
    }
    return res;
  },
  (error) => notifyAxiosError(error, hideMask)
);

export default service
